import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import routes from "./routes";
import { useStore } from "../store/store.context";

const PrivateRoute = ({ children }) => {
  const { store } = useStore();
  const location = useLocation();

  const currentRoute = routes.find((route) => route.path === location.pathname);
  const requiresAuth = currentRoute?.requiresAuth;

  // Simple token-based authentication check
  const hasToken = sessionStorage.getItem('authToken');
  const hasUserInfo = sessionStorage.getItem('userInfo');
  const userIsAuthenticated = !!(hasToken && hasUserInfo);
  
  // Check if user just completed authentication
  const justAuthenticated = sessionStorage.getItem('justAuthenticated') === 'true';


  // If route doesn't require auth, always allow
  if (!requiresAuth) {
    return children;
  }

  // If user just authenticated, always allow (even if store hasn't updated yet)
  if (justAuthenticated && userIsAuthenticated) {
    console.log('PrivateRoute: Allowing access - user just authenticated');
    return children;
  }

  // If user is not authenticated, redirect to login
  if (!userIsAuthenticated || (store && store.appLogout)) {
    console.log('PrivateRoute: Redirecting to login');
    return <Navigate to="/login-page" replace />;
  }

  // User is authenticated and route requires auth
  return children;
};

export default PrivateRoute;
